import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import {
  APIgetClientStats,
  APIdeleteClient,
} from '../../../api/Clients';

import ProcessingSpinner from '../../ProcessingSpinner';

import { addFlashMessage } from '../../../helpers/FlashMessages';

import ErrorBoundary from '../../ErrorBoundary';
import Loading from '../../Loading';

const AdminPanelAccountsDeleteModal = ({
  clientUuid,
  handleClose,
  afterClientDeleted,
}) => {
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState(false);

  const intl = useIntl();

  useEffect(() => {
    setLoading(true);
    APIgetClientStats(clientUuid).then((response) => {
      setClient(response);
      setLoading(false);
    });
  }, [clientUuid]);

  const handleDelete = () => {
    setDeleting(true);
    APIdeleteClient(client.uuid).then(() => {
      afterClientDeleted(client);
      setDeleting(false);
      addFlashMessage({
        type: 'success',
        text: intl.formatMessage({
          defaultMessage: 'Client has been deleted',
        }),
      });
      handleClose();
    });
  };

  return (
    <ErrorBoundary>
      <ModalHeader>
        {intl.formatMessage({ defaultMessage: 'Delete client' })}
      </ModalHeader>
      <ModalBody>
        {loading ? (
          <Loading />
        ) : (
          <div>
            <p className="error center">
              <strong>
                {intl.formatMessage({ defaultMessage: 'This client and all related content will be permanently removed from our servers. This cannot be undone.' })}
              </strong>
            </p>
            <strong>{intl.formatMessage({ defaultMessage: 'Name' })}</strong>: {client.display_name}<br />
            <strong>{intl.formatMessage({ defaultMessage: 'Domain' })}</strong>: {client.domain}<br />
            <strong>{intl.formatMessage({ defaultMessage: 'Users' })}</strong>: {client.users}<br />
            <strong>{intl.formatMessage({ defaultMessage: 'Files' })}</strong>: {client.files}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <div className="buttons-group">
          {!deleting && (
            <Button
              color="secondary"
              onClick={handleClose}
            >
              {intl.formatMessage({ defaultMessage: 'Cancel' })}
            </Button>
          )}
          <Button
            className="confirmation-button"
            color="primary"
            disabled={deleting}
            onClick={handleDelete}
          >
            <ProcessingSpinner show={deleting} />
            {deleting ?
              intl.formatMessage({ defaultMessage: 'Deleting...' }) :
              intl.formatMessage({ defaultMessage: 'Delete' })}
          </Button>
        </div>
      </ModalFooter>
    </ErrorBoundary>
  );
};

AdminPanelAccountsDeleteModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  afterClientDeleted: PropTypes.func.isRequired,
  clientUuid: PropTypes.string.isRequired,
};

export default AdminPanelAccountsDeleteModal;
